function international_filter_controller(el_container, a_countries, base_url) {
    const el_open_state = el_container.querySelector("#international-filter-open-status");
    const el_popup_container = el_container.querySelector(".international-filter__filter-outer-container");
    const el_text_input = el_container.querySelector(".international-filter__text-input");
    const el_result_list = el_container.querySelector(".international-filter__filter-result-list");
    const el_close = el_container.querySelector(".international-filter__filter-close-mobile");
    const el_no_results_message = el_container.querySelector(".international-filter__no-results-message");

    const build_list_item = (name) => {
        const el_item = document.createElement("LI");
        const el_link = document.createElement("A");
        const url = base_url + "/country-filter-" + name_to_tag(name);
        el_item.appendChild(el_link);
        el_link.href = url;
        el_link.innerText = name;
        return el_item;
    };

    const name_to_tag = (name) => {
        return name.toLowerCase().replaceAll(' ', '-');
    }

    const do_filter = (term) => {
        el_open_state.checked = true;
        el_result_list.innerHTML = '';
        const maching = [];
        a_countries.forEach(function(country){
            if (country.toLowerCase().search(term.toLowerCase()) !== -1) {
                maching.push(country);
            }
        });
        if (maching.length == 0) {
            el_no_results_message.style['display'] = 'block';
        }
        else {
            el_no_results_message.style['display'] = 'none';
            maching.forEach(function(country){
                el_result_list.appendChild(build_list_item(country));
            });
        }
    };

    const text_changed = (e) => {
        do_filter(el_text_input.value);
    };

    const background_clicked = (e) => {
        el_open_state.checked = false;
        el_result_list.innerHTML = '';
        el_text_input.value = '';
    };

    const setup = () => {
        el_no_results_message.style['display'] = 'none';
        el_text_input.addEventListener("keyup", text_changed);
        el_container.addEventListener("click", (e) => {
            e.stopPropagation();
        });
        document.addEventListener("click", background_clicked);
        el_close.addEventListener("click", () => {
            el_open_state.checked = false;
        });
    };
    setup();
}
